namespace $.$$ {

	$mol_style_define( $.$hyoo_sketch_element_attach, {

	} )

}
